export enum AddBundleRequestType {
  SINGLE_PLAN = 1,
  FAMILY_PLAN_EXISTING_CUSTOMER = 2,
  FAMILY_PLAN_NEW_CUSTOMER = 3,
}

export type AddBundleToCartRequestModel = {
  BundleRequestType?: AddBundleRequestType;
  BundlePriceId?: number;
  AddRequiredProducts?: boolean;
  DownPayTime?: number;
  NumberOfFamilyPlans?: number;
  MainFamilyPlanCellPhoneNumber?: string;
  FamilyBundlePriceId?: number;
};
